import React, { useState } from 'react';

const NextIcon = ({
  width = 16,
  height = 16,
  color = '#7F7182',
  hoverColor = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  className = '',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M3.00267 2.75731L11.0027 7.42398C11.1034 7.48267 11.1869 7.56675 11.245 7.66781C11.3031 7.76888 11.3337 7.88341 11.3337 7.99998C11.3337 8.11655 11.3031 8.23108 11.245 8.33215C11.1869 8.43322 11.1034 8.51729 11.0027 8.57598L3.00267 13.2427C2.90135 13.3018 2.78623 13.3331 2.66893 13.3335C2.55163 13.3339 2.4363 13.3033 2.33458 13.2449C2.23287 13.1865 2.14837 13.1023 2.08963 13.0007C2.03088 12.8992 1.99996 12.784 2 12.6666V3.33331C1.99996 3.21601 2.03088 3.10078 2.08963 2.99924C2.14837 2.89771 2.23287 2.81348 2.33458 2.75505C2.4363 2.69662 2.55163 2.66606 2.66893 2.66645C2.78623 2.66685 2.90135 2.69819 3.00267 2.75731ZM13.3333 2.66665C13.17 2.66667 13.0124 2.72662 12.8904 2.83512C12.7684 2.94363 12.6904 3.09315 12.6713 3.25531L12.6667 3.33331V12.6666C12.6669 12.8366 12.7319 13 12.8486 13.1236C12.9652 13.2471 13.1246 13.3215 13.2943 13.3314C13.4639 13.3414 13.6309 13.2862 13.7612 13.1771C13.8915 13.0681 13.9753 12.9134 13.9953 12.7446L14 12.6666V3.33331C14 3.1565 13.9298 2.98693 13.8047 2.86191C13.6797 2.73689 13.5101 2.66665 13.3333 2.66665Z"
        fill={isHovered ? hoverColor : color}
      />
    </svg>
  );
};

export default NextIcon;
